import { selectReferenceBarUI } from "../../redux/features/selectors/referenceBarUISelectors.ts";
import { useAppSelector } from "../../redux/hooks.ts";
import { Tkv2ReferenceBarItem } from "./Tkv2ReferenceBarItem.tsx";
import { useTkv2HandleIconClick } from "./useTkv2HandleIconClick.ts";

export const Tkv2ClientInformationItem = () => {
  const { referenceViewOpen, selectedDataSheet } = useAppSelector(selectReferenceBarUI);
  const handleIconClick = useTkv2HandleIconClick();

  const isSelected = selectedDataSheet === 'client-information' && referenceViewOpen;

  return (
    <Tkv2ReferenceBarItem
      id="client_information"
      label="Client Information"
      icon="people"
      isSelected={isSelected}
      onClick={() => handleIconClick('client-information')}
    />
  );
};
